import { optInGuestToChat } from 'actions/messaging'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import usePlausible from 'hooks/usePlausible'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import subscribersApi from 'services/api/subscribers'

import styles from './ConsentRequestDialog.module.scss'

const consentOptionTypes = {
  askForConsent: 'askForConsent',
  forceConsent: 'forceConsent'
}

const { askForConsent, forceConsent } = consentOptionTypes

const ConsentRequestDialog = ({ onClose, chatId }) => {
  const [selectedOption, setSelectedOption] = useState(askForConsent) // askForConsent, forceConsent
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()

  const { postEvent, plausibleEvents } = usePlausible()

  async function handleSubmit() {
    setIsLoading(true)
    if (selectedOption === askForConsent) {
      postEvent(plausibleEvents.InviteToOptIn, {
        chatId
      })

      await subscribersApi.sentConsentRequestText({ chatId })
    } else {
      await dispatch(optInGuestToChat({ chatId }))

      postEvent(plausibleEvents.ForceOptIn, {
        chatId
      })
    }
    setIsLoading(false)
    onClose()
  }

  return (
    <ConfirmationDialog
      title="Request consent to send guest marketing messages"
      theme="blacklist"
      positiveMessage="Continue"
      negativeMessage="Cancel"
      isButtonDisabled={isLoading}
      isRejectButtonDisabled={isLoading}
      onConfirm={handleSubmit}
      onReject={onClose}
    >
      <p className={styles.optionLabel}>Select an option to continue</p>
      {isLoading && <LoadingIndicator className={styles.loadingIndicator} />}
      <div
        className={styles.consentOptions}
        style={{
          pointerEvents: isLoading ? 'none' : 'auto',
          opacity: isLoading ? 0.3 : 1
        }}
      >
        <label
          className={
            selectedOption === askForConsent ? styles.selectedOption : styles.option
          }
        >
          <input
            type="radio"
            name="consentOption"
            value="askForConsent"
            checked={selectedOption === askForConsent}
            onChange={() => setSelectedOption(askForConsent)}
          />
          <div className={styles.optionText}>
            <p className={styles.optionTitle}>
              Send guest a message to ask for their consent
            </p>
            <p className={styles.optionDescription}>
              <svg
                width="13"
                height="15"
                viewBox="0 0 13 15"
                fill="none"
                style={{ marginRight: '5px' }}
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.134875 2.79864C2.48717 2.76567 4.74891 1.77122 6.5 0C8.25097 1.77155 10.5127 2.76633 12.8651 2.79956C12.9545 3.39502 13 4.00879 13 4.63265C13 9.4192 10.2862 13.4912 6.5 15C2.71375 13.4903 0 9.41828 0 4.63173C0 4.00696 0.0463124 3.39502 0.134875 2.79864ZM9.51194 6.19549C9.65994 6.02272 9.74184 5.79131 9.73998 5.55112C9.73813 5.31092 9.65268 5.08116 9.50204 4.91131C9.3514 4.74146 9.14761 4.64511 8.93458 4.64302C8.72154 4.64094 8.5163 4.73327 8.36306 4.90015L5.6875 7.91682L4.63694 6.73232C4.4837 6.56545 4.27846 6.47311 4.06542 6.4752C3.85239 6.47729 3.6486 6.57363 3.49796 6.74348C3.34732 6.91333 3.26187 7.14309 3.26001 7.38329C3.25816 7.62348 3.34006 7.85489 3.48806 8.02767L5.11306 9.85984C5.26543 10.0316 5.47205 10.1281 5.6875 10.1281C5.90295 10.1281 6.10957 10.0316 6.26194 9.85984L9.51194 6.19549Z"
                  fill="#66BB6A"
                />
              </svg>
              This is recommended for best compliance practices
            </p>
          </div>
        </label>
        <label
          className={
            selectedOption === forceConsent ? styles.selectedOption : styles.option
          }
          onClick={() => setSelectedOption(forceConsent)}
        >
          <input
            type="radio"
            name="consentOption"
            value="forceConsent"
            checked={selectedOption === forceConsent}
            onChange={() => setSelectedOption(forceConsent)}
          />
          <div className={styles.optionText}>
            <p className={styles.optionTitle}>Set guest's status to “consent received”</p>
            <p className={styles.optionDescription}>
              Only use this option if you've received explicit written consent
            </p>
          </div>
        </label>
      </div>
    </ConfirmationDialog>
  )
}

export default ConsentRequestDialog
